<template>
  <div class="page-header-index-wide">
    <a-card :bordered="false" >
      <div style="position: relative; width: 100%;">
        <div>
          <a-tabs defaultActiveKey="1" :tabPosition="mode" @prevClick="callback" @nextClick="callback">
            <a-tab-pane tab="鲁教版六年级上" key="1">
              <a-row :gutter="8">
                <a-col :span="6" v-for="(item, index) in data" :key="index">
                  <div class="news_reading" style="float:left; " >
                    <a-card
                      hoverable
                      style="width: 240px"
                      @click="reading"
                    >
                      <img
                        alt="example"
                        :src="item.img"
                        slot="cover"
                      />
                      <a-card-meta
                        :title="item.title">
                        <span slot="description">
                          {{ item.description }}<br>
                        </span>
                      </a-card-meta>
                      <span style="float:right;color:blue">{{ item.type }}</span>
                    </a-card>
                  </div>
                </a-col>
              </a-row>
            </a-tab-pane>
            <a-tab-pane tab="鲁教版六年级中" key="2">
              <a-row :gutter="8">
                <a-col :span="6">
                  <div class="news_reading" style="float:left; " >
                    <a-card
                      hoverable
                      style="width: 240px"
                      @click="reading"
                    >
                      <img
                        alt="example"
                        src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1553165104773&di=e63943b4e13617629a870f07e8969094&imgtype=0&src=http%3A%2F%2Fmpic.tiankong.com%2F883%2Fc1d%2F883c1d75115c394fddd5060942b2a540%2F640.jpg"
                        slot="cover"
                      />
                      <a-card-meta
                        title="Book 1">
                        <span slot="description">
                          Waiting for Goldie<br>
                        </span>
                      </a-card-meta>
                      <span style="float:right;color:blue">未练习</span>
                    </a-card>
                  </div>
                </a-col>
              </a-row>
            </a-tab-pane>
            <a-tab-pane tab="鲁教版六年级下" key="3">
              <a-row :gutter="8">
                <a-col :span="6">
                  <div class="news_reading" style="float:left; " >
                    <a-card
                      hoverable
                      style="width: 240px"
                      @click="reading"
                    >
                      <img
                        alt="example"
                        src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1553165104773&di=e63943b4e13617629a870f07e8969094&imgtype=0&src=http%3A%2F%2Fmpic.tiankong.com%2F883%2Fc1d%2F883c1d75115c394fddd5060942b2a540%2F640.jpg"
                        slot="cover"
                      />
                      <a-card-meta
                        title="Book 1">
                        <span slot="description">
                          Waiting for Goldie<br>
                        </span>
                      </a-card-meta>
                      <span style="float:right;color:blue">未练习</span>
                    </a-card>
                  </div>
                </a-col>
              </a-row>
            </a-tab-pane>

          </a-tabs>
        </div>
      </div>
      <div style="margin-top: 30px; float: right;">
        <a-pagination :defaultCurrent="6" :total="1" />
      </div>
    </a-card>
  </div>
</template>
<script>
const data = [
  {
    img: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1553165104773&di=e63943b4e13617629a870f07e8969094&imgtype=0&src=http%3A%2F%2Fmpic.tiankong.com%2F883%2Fc1d%2F883c1d75115c394fddd5060942b2a540%2F640.jpg',
    type: '未练习',
    title: 'Book 1',
    description: 'Waiting for Goldie'
  },
  {
    img: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1553165104773&di=e63943b4e13617629a870f07e8969094&imgtype=0&src=http%3A%2F%2Fmpic.tiankong.com%2F883%2Fc1d%2F883c1d75115c394fddd5060942b2a540%2F640.jpg',
    type: '未练习',
    title: 'Book 1',
    description: 'Waiting for Goldie'
  },
  {
    img: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1553165104773&di=e63943b4e13617629a870f07e8969094&imgtype=0&src=http%3A%2F%2Fmpic.tiankong.com%2F883%2Fc1d%2F883c1d75115c394fddd5060942b2a540%2F640.jpg',
    type: '未练习',
    title: 'Book 1',
    description: 'Waiting for Goldie'
  },
  {
    img: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1553165104773&di=e63943b4e13617629a870f07e8969094&imgtype=0&src=http%3A%2F%2Fmpic.tiankong.com%2F883%2Fc1d%2F883c1d75115c394fddd5060942b2a540%2F640.jpg',
    type: '未练习',
    title: 'Book 1',
    description: 'Waiting for Goldie'
  }
]
export default {

  data () {
    return {
      mode: 'top',
      modes: 'left',
      data,
      vable: false,
      editorContent: '<p> Lo, praise of the prowess of people-kings</p><p> of spear-armed Danes, in days long sped,</p><p> we have heard, and what honor the athelings won!</p><p> Oft Scyld the Scefing from squadroned foes,</p><p> from many a tribe, the mead-bench tore,</p><p> Lo, praise of the prowess of people-kings</p><p> of spear-armed Danes, in days long sped,</p><p> we have heard, and what honor the athelings won!</p><p> Oft Scyld the Scefing from squadroned foes,</p><p> from many a tribe, the mead-bench tore,</p><p> Lo, praise of the prowess of people-kings</p><p> of spear-armed Danes, in days long sped,</p><p> we have heard, and what honor the athelings won!</p><p> Oft Scyld the Scefing from squadroned foes,</p><p> from many a tribe, the mead-bench tore,</p><p> Lo, praise of the prowess of people-kings</p><p> of spear-armed Danes, in days long sped,</p><p> we have heard, and what honor the athelings won!</p><p> Oft Scyld the Scefing from squadroned foes,</p><p> from many a tribe, the mead-bench tore,</p><p> Lo, praise of the prowess of people-kings</p><p> of spear-armed Danes, in days long sped,</p><p> we have heard, and what honor the athelings won!</p><p> Oft Scyld the Scefing from squadroned foes,</p><p> from many a tribe, the mead-bench tore,</p><p> Lo, praise of the prowess of people-kings</p><p> of spear-armed Danes, in days long sped,</p><p> we have heard, and what honor the athelings won!</p><p> Oft Scyld the Scefing from squadroned foes,</p><p> from many a tribe, the mead-bench tore,</p>'
    }
  },
  methods: {
    callback (val) {
      console.log(val)
    },
    reading () {
      this.$router.push({ name: 'readsection' })
    },
    readingOk () {
      this.vable = false
    },
    Cancel () {
      this.vable = false
    }
  },
  components: {

  }

}
</script>
<style>
.news_box{
  background-color: #fff;
}
.news_reading{
    padding: 5px;
    margin: 30px;
    width: 240px;
    position: relative;
    /* border: 1px solid #ccc;
    box-sizing: content-box; */
}
.news_reading img{
    padding-top: 3px;
}

</style>
